export const API_PORT = process.env.NODE_ENV == 'production' ? '8888' : '8087';
//export const API_PORT = '8088'

let localApiURL = process.env.VUE_APP_API_URL

switch (process.env.NODE_ENV) {
    case 'production':
        //localApiURL = 'https://app.gingerteam.pro/api';
        localApiURL = 'https://gumait.tech/api';
        break;
    case 'demo':        
        //localApiURL = 'http://localhost:8088/api'; 
        localApiURL = 'https://demo.gumait.tech/api';
        break;        
  }

//localApiURL = 'http://demo.ginger.ru:8088/api';  
//localApiURL = 'https://app.gingerteam.pro/api';  // prod

// если в .env.local заполнен VUE_APP_API_URL тогда берем его иначе localhost с портом по умолчанию
export const API_URL = localApiURL?.length > 0 ? localApiURL : `http://localhost:${API_PORT}/api` 

console.log('API_URL', API_URL)

export const DOMAIN_TITLE = 'gingerteam.pro'
